import HttpClientToken from '../../services/HttpClientToken';

import { defaultEtapa, EtapaProps } from '../../interfaces/catalogos/EtapaInterface';

export const Etapa = () => {

    return new Promise<EtapaProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/Etapa/', token)
            .then( ({ data } : { data : EtapaProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ObtenerEtapa = () => {

    return new Promise<EtapaProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/Etapa/ObtenerEtapa', token)
            .then( ({ data } : { data : EtapaProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ActualizarEtapa = ( params: EtapaProps ) => {

    return new Promise<EtapaProps>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Etapa/Actualizar', params, token)
            .then( ({ data } : { data : EtapaProps} ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultEtapa } );
            });

        }

    });

}

export const AgregarEtapa = ( params: EtapaProps ) => {

    return new Promise<EtapaProps>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Etapa/Agregar', params, token)
            .then( ({ data } : { data : EtapaProps} ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultEtapa } );
            });

        }

    });

}
